/**
 * Nome curto pra saudações ("Olá, X") e chips de header. Cuidado especial
 * pra brokers PV cujo "name" geralmente é o nome empresarial completo
 * ("Risco Zero Proteção Veicular") · pegar `split(' ')[0]` geraria
 * "Olá, Risco!" que soa errado.
 *
 * Regra:
 *  - PV: as 2 primeiras palavras (cobre nomes empresariais tipo "Risco Zero",
 *    "Auto Forte", "Proteção Total")
 *  - default (MCMV ou desconhecido): a primeira palavra (primeiro nome de
 *    pessoa, comportamento clássico)
 *
 * Quando o nome já é curto, ambos os caminhos retornam o nome completo.
 */
export function shortBrokerName(name: string, verticalKey?: string): string {
  const trimmed = name.trim();
  if (!trimmed) return name;
  const parts = trimmed.split(/\s+/);
  if (verticalKey === 'protecao-veicular') {
    return parts.slice(0, 2).join(' ');
  }
  return parts[0] ?? trimmed;
}
